<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'VERIFY_CARD.TITLE' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button color="toolbar-button" (click)="close()">
        {{ 'APP.CLOSE' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <iframe
    *ngIf="url && !success"
    class="verification-iframe"
    allow="payment"
    (error)="onError($event)"
    #dropinIframe
    [src]="url"
    [name]="appVersion"></iframe>

  <div class="ion-padding" *ngIf="!url && !success">
    <div class="ion-text-center">
      <ion-spinner *ngIf="loading" name="dots"></ion-spinner>
    </div>
    <div class="ion-text-center ion-padding-top">
      <a
        href="https://www.braintreegateway.com/merchants/2b8tv22q2hkjsrtd/verified"
        target="_blank">
        <img
          src="https://s3.amazonaws.com/braintree-badges/braintree-badge-wide-light.png"
          width="280px"
          height="44px"
          border="0" />
      </a>
    </div>
  </div>
  <span *ngIf="success" class="ion-padding ion-text-center">
    <svg
      class="checkmark"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 52 52">
      <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
      <path
        class="checkmark__check"
        fill="none"
        d="M14.1 27.2l7.1 7.2 16.7-16.8" />
    </svg>
    <h1>{{ 'VERIFY_CARD.METHOD_VERIFIED' | translate }}</h1>
  </span>
</ion-content>
